import { render, staticRenderFns } from "./SnapshotReviewModal.vue?vue&type=template&id=82852a98&scoped=true&"
import script from "./SnapshotReviewModal.vue?vue&type=script&lang=js&"
export * from "./SnapshotReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotReviewModal.vue?vue&type=style&index=0&id=82852a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82852a98",
  null
  
)

export default component.exports